import React, {PureComponent} from 'react';


/**
 * 充值按钮
 */
export default class TopUp extends PureComponent {
    constructor(props) {
        super(props);

        this.topup = this.topup.bind(this);
        this.preventDefault = this.preventDefault.bind(this);
    }

    topup(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.fShowPayPanel && this.props.fShowPayPanel();
    }

    preventDefault(event) {
        event.preventDefault();
    }

    render() {
        return(
            <a href="" title="充值" onClick={this.topup} className={this.props.className} data-stat={this.props.dataStat}>
                {this.props.children}
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/components/button/TopUp.jsx